/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProcessState } from "./ProcessState";
import {
  ProcessStateFromJSON,
  ProcessStateFromJSONTyped,
  ProcessStateToJSON,
} from "./ProcessState";

export interface IngestionPartUpdateRequest {
  locked?: boolean;
  workflowId?: string | null;
  workflowContext?: object | null;
  state?: ProcessState;
  progress?: number | null;
  errorName?: string | null;
  errorMessage?: string | null;
  errorPayload?: object | null;
  error?: object | null;
  sequence?: number;
  source?: string | null;
  context?: object | null;
  index?: Array<any> | null;
}

export function IngestionPartUpdateRequestFromJSON(
  json: any,
): IngestionPartUpdateRequest {
  return IngestionPartUpdateRequestFromJSONTyped(json);
}

export function IngestionPartUpdateRequestFromJSONTyped(
  json: any,
): IngestionPartUpdateRequest {
  if (json == null) {
    return json;
  }

  return {
    locked: json["locked"],
    workflowId: json["workflow_id"],
    workflowContext: json["workflow_context"],
    state:
      json["state"] === undefined
        ? undefined
        : ProcessStateFromJSON(json["state"]),
    progress: json["progress"],
    errorName: json["error_name"],
    errorMessage: json["error_message"],
    errorPayload: json["error_payload"],
    error: json["error"],
    sequence: json["sequence"],
    source: json["source"],
    context: json["context"],
    index: json["index"],
  };
}

export function IngestionPartUpdateRequestToJSON(
  value: IngestionPartUpdateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    locked: value.locked,
    workflow_id: value.workflowId,
    workflow_context: value.workflowContext,
    state: ProcessStateToJSON(value.state),
    progress: value.progress,
    error_name: value.errorName,
    error_message: value.errorMessage,
    error_payload: value.errorPayload,
    error: value.error,
    sequence: value.sequence,
    source: value.source,
    context: value.context,
    index: value.index,
  };
}
